import api from "./api";
import {STATUS_HTTP} from "./statusHTTP";
import {iniciarRequisicao, logout} from "../helpers/index.js";

export const buscarListasDeSecoes = async (requisicao) => {
  let url= `/compradores/secao-vincular-comprador`

  const {status, data} = await api.get(url, {requisicao, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secoes;
  }

  logout();
}

export const buscarListaDeDepartamentos = async (requisicao) => {
  let url= `/compradores/lista-departamentos`

  const {status, data} = await api.get(url, {requisicao, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.secoes;
  }

  logout();
}

export const vincularSecoesAoComprador = async (params) => {
  let url= `/compradores/vinculacao/secoes`

  const {status, data} = await api.put(url, params, { headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.select;
  }

  logout();
}

export const vincularDepartamentosAoComprador = async (params) => {
  let url= `/compradores/vinculacao/departamentos`

  const {status, data} = await api.put(url, params, { headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.select;
  }

  logout();
}
